import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const Button = ({
  children,
  className = '',
  id,
  onClick = () => {},
  ...nativeProps
}) => {
  return (
    <button
      className={`${cx('button')} ${className}`}
      id={id}
      onClick={() => onClick()}
      {...nativeProps}
    >
      {children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  styles: PropTypes.object
};
